<div class="mat-elevation-z8">
  <mat-card>
    <mat-card-content>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="custom-tabs"
        [selectedIndex]="activeTabIndex()" (selectedTabChange)="onTabIndexChange($event.index)" [dynamicHeight]="true">
        <mat-tab label="Customers" class="custom-tabs">
          <ng-template matTabContent>

            <app-filter-control [tabIndex]="0" [addButtonText]="'Customer'" [searchPlaceholder]="'Filter Customers'"
              (filterChanged)="handleFilterChange($event)" (addClicked)="handleAddClicked()"
              (searchChanged)="handleSearchFilterChange($event)"
              [canAdd]="controlPermissions.addCustomer"></app-filter-control>

            <app-generators [filterState]="currentFilterState()" [refreshTrigger]="refreshCounter()"
              [gridSearchText]="searchQuery()"></app-generators>
          </ng-template>
        </mat-tab>
        <mat-tab label="Streams">
          <ng-template matTabContent>
            <app-filter-control [tabIndex]="1" [addButtonText]="'Stream'" [searchPlaceholder]="'Filter Streams'"
              (filterChanged)="handleFilterChange($event)" (addClicked)="handleAddClicked()"
              (existingStreamsClicked)="handleExistingStreamsClicked()"
              (searchChanged)="handleSearchFilterChange($event)" [canAdd]="controlPermissions.addStream"
              [canAddExisting]="controlPermissions.addExistingStream"></app-filter-control>
            <app-streams [filterState]="currentFilterState()" [refreshTrigger]="refreshCounter()"
              [gridSearchText]="searchQuery()"></app-streams>
          </ng-template>
        </mat-tab>
        <mat-tab label="Price Matrix">
          <ng-template matTabContent>
            <app-filter-control [tabIndex]="2" [addButtonText]="'Price Matrix'"
              [searchPlaceholder]="'Filter Price Matrix'" (filterChanged)="handleFilterChange($event)"
              (addClicked)="handleAddClicked()" (searchChanged)="handleSearchFilterChange($event)"
              [canAdd]="controlPermissions.addPriceMatrix"></app-filter-control>
            <app-pricematrix [filterState]="currentFilterState()" [refreshTrigger]="refreshCounter()"
              [gridSearchText]="searchQuery()"></app-pricematrix>
          </ng-template>
        </mat-tab>
        @if(controlPermissions.showToteTab){
          <mat-tab label="Tote Price Matrix">
            <ng-template matTabContent>
              <app-filter-control [tabIndex]="3" [addButtonText]="'Tote Price Matrix'"
                [searchPlaceholder]="'Filter Tote Price Matrix'" (filterChanged)="handleFilterChange($event)"
                (addClicked)="handleAddClicked()" (searchChanged)="handleSearchFilterChange($event)"
                [canAdd]="controlPermissions.addTotePriceMatrix"></app-filter-control>
              <app-totepricematrix [filterState]="currentFilterState()" [refreshTrigger]="refreshCounter()"
                [gridSearchText]="searchQuery()"></app-totepricematrix>
            </ng-template>
          </mat-tab>
        }
        @if (controlPermissions.showLabTab) {
          <mat-tab label="Lab Data">
            <ng-template matTabContent>
              <app-filter-control [tabIndex]="10" (filterChanged)="handleFilterChange($event)"
                (addClicked)="handleAddClicked()"
                [addButtonText]="labDataTabIndex() === 0 ? 'Chemistry Result' : 'Metal Result'"
                [searchPlaceholder]="labDataTabIndex() === 0 ? 'Filter Chemistry Results' : 'Filter Metal Results'"
                [canAdd]="labDataTabIndex() === 0 ? controlPermissions.addChemistry : controlPermissions.addMetal"
                (searchChanged)="handleSearchFilterChange($event, 10)"></app-filter-control>
              <app-labdata [selectedIndex]="labDataTabIndex()" (tabChange)="labDataTabIndex.set($event)"
                [filterState]="currentFilterState()" [refreshTrigger]="refreshCounter()"
                [gridSearchText]="searchQuery()"></app-labdata>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>